import { ProductType } from '../../constants';
import type { CartItemResponse, Product } from '../../model';

/** Exclude a parent product when any of its options is already in the bag. */
export function filterCartRecommendations(products: Product[], items: CartItemResponse[]) {
  const cartIds = new Set(items.map((item) => item.productId));
  const cartSkus = new Set(items.map((item) => item.sku).filter(Boolean));
  const seen = new Set<number>();

  return products.filter((product) => {
    if (product.status === 'outofstock' || seen.has(product.productId)) return false;
    seen.add(product.productId);
    const candidates = product.type === ProductType.Variable ? [product, ...product.variations] : [product];
    return !candidates.some((candidate) => cartIds.has(candidate.productId) || cartSkus.has(candidate.sku));
  });
}
